module.exports = __webpack_public_path__ + "img/swatch-0.caa0dee8.png";